import classNames from "classnames";
import { html, TemplateResult } from "lit-html";
import { City, Country } from "Components/searchbox/searchTab/flights/RoutePickerModel";
import { stationSelectorCountryArrowMobile } from "Components/searchbox/searchTab/flights/station-selector/newFlightSvgs";
import i18next from "i18next";
import { ALL_COUNTRY_CODE } from "Components/searchbox/searchTab/flights/station-selector/stationUtils";

export const allStationsPlaceholder: Country = {
	cities: [],
	code: ALL_COUNTRY_CODE,
	isAvailableForPeruCompras: false,
	name: i18next.t("Todos los destinos"),
};

export const hasRelevantDestinations = (country: Country | undefined, originCity: City): boolean =>
	country?.cities.some((city) => city.markets.includes(originCity.code)) ?? false;

export const findCountryInModel = (filteredModel: Country[], countryCode: string): Country | undefined =>
	filteredModel.find((country) => country.code.toLowerCase() === countryCode.toLowerCase());

export const highlightTextTemplate = (text: string, query: string): string | TemplateResult => {
	if (!query) return text;

	const index = text.toLowerCase().indexOf(query.toLowerCase());
	if (index === -1) return text;

	const before = text.substring(0, index);
	const match = text.substring(index, index + query.length);
	const after = text.substring(index + query.length);

	return html`${before}<span class="text-n-cyan">${match}</span>${after}`;
};

export const stationCountryArrowTemplate = (countryCode: string, openCountryCodes: Set<string>): TemplateResult => html`
	<span
		class=${classNames("common-transition", {
			"rotate-180 transform": !openCountryCodes.has(countryCode),
		})}
	>
		${stationSelectorCountryArrowMobile}
	</span>
`;
